<template>
  <div id="app">
      <WebHeader></WebHeader>
      <router-view  :key="$route.path"></router-view>
      <WebFooter></WebFooter>
  </div>
</template>
<script>
    import Header from './views/header';
    import Footer from './views/footer';
    export default {
        components:{
            WebHeader: Header,
            WebFooter: Footer,
        },

    }
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
